export enum BadgeQueryKeyType {
  BADGE_LIST = 'badgeList',
  TOGGLE_BADGE = 'toggleBadge',
}
